import React from 'react'
import { Link } from 'react-router-dom'
import logoFile from '../../../assets/images/logo.png'

const DesktopNav = () => {
  return (
    <>
      <nav className="hidden w-full justify-center xl:flex" data-testid="desktop_navigation__item">
        <ul className="hidden items-center text-center lg:flex" id="navbar_ul">
          <LeftNavLinks />
          <li className="inline-block px-4">
            <Link to="/" data-testid="logo-link">
              <img src={logoFile} alt="Cypher-Tech Labs - Smart Contract Audits, Token and NFT Developer, Custom Software Applications, and much more!" id="logo_file" />
            </Link>
          </li>
          <RightNavLinks />
        </ul>
      </nav>
    </>
  );
}

const LeftNavLinks = () => {
  const leftLinks = [
    { name: 'Home', path: '/', id: 'home__route' },
    { name: 'SmartContracts & Audits', path: '/smart-contracts-and-audits', id: 'smart_contracts_and_audits__route' },
    { name: 'KYC/Penetration Testing', path: '/kyc-verification-penetration-testing-bug-bounty', id: 'kyc_verification_penetration_testing_and_bug_bounty__route' },
    { name: 'Bug Bounty', path: '/kyc-verification-penetration-testing-bug-bounty#bug_bounty', id: 'kyc_verification_penetration_testing_and_bug_bounty__route#bug_bounty' },
    { name: 'CMMC', path: '/cmmc-compliance', id: 'cmmc_compliance__route' },
  ]

  return (
    <>
      {leftLinks.map((link, index) => (
        <li key={index} className="inline-block px-4 text-xl">
          <Link to={link.path}>{link.name}</Link>
        </li>
      ))}
    </>
  );
}

const RightNavLinks = () => {
  const rightLinks = [
    { name: 'Crypto Environments', path: '/crypto-environments', id: 'crypto_environments__route' },
    { name: 'Custom Development', path: '/custom-development', id: 'custom_development__route' },
    { name: 'Payments', path: '/payment-options', id: 'payment_options__route' },
    { name: 'Blog', path: 'https://blog.cyphertech-labs.io/', id: 'blog__route', external: true },
    { name: 'Contact', path: '/contact-us', id: 'contact_us__route' },
  ]

  return (
    <>
      {rightLinks.map((link, index) => (
        <li key={index} className="inline-block px-4 text-xl">
          <Link to={link.path}>{link.name}</Link>
        </li>
      ))}
    </>
  );
}


export default DesktopNav;